import * as Customer from './customer';
import * as Kiosk from './kiosk';
import * as Order from './orders';

export { Customer, Order, Kiosk };
